const AppConfig = {

    LOGIN_TYPE_ADMIN:"Admin",
}
export default AppConfig;